import classNames from 'classnames/bind';
import styles from './Classroom.module.css';

import SimpleBar from 'simplebar-react';
import useSimpleBar from '../../hooks/useSimpleBar';
import { Outlet, useLocation } from 'react-router-dom';

import Container from '../../components/Container';
import TopArea from '../../components/TopArea';

import { CLASSROOM } from '../../constants';

export default function Classroom() {
  const cx = classNames.bind(styles);
  const [simplebarRef] = useSimpleBar();
  const { pathname } = useLocation();
  const path = pathname.split('/').splice(-1)[0];

  const isNarrow = ['classroom'].includes(path);
  const isLearningActivity = path.includes('activity');
  const isBulkAdd = pathname.includes('student-bulk-add');

  return (
    <Container isSubPage={true}>
      <TopArea title={CLASSROOM} className="st_subpage" />
      <div className={cx('content', { settings: !isLearningActivity })}>
        <div
          className={cx({
            section: !isLearningActivity,
            bulk_add_area: isBulkAdd,
          })}
        >
          <SimpleBar forceVisible={true} ref={simplebarRef}>
            <div
              className={cx('setting_area', isNarrow ? 'mx_min' : 'mx_full', {
                bulk_add_area: isBulkAdd,
                request: path.includes('request'),
              })}
            >
              <Outlet></Outlet>
            </div>
          </SimpleBar>
        </div>
      </div>
    </Container>
  );
}
